import { Component, OnInit } from '@angular/core';
import {DataService} from '../../../../../../services/commande-client/data.service';
import {AchatService} from '../../../../../../services/achat/achat.service';

@Component({
  selector: 'app-tous-fac-f',
  templateUrl: './tous-fac-f.component.html',
  styleUrls: ['./tous-fac-f.component.scss']
})
export class TousFacFComponent implements OnInit {

    constructor(private dataService: AchatService) {}

    ngOnInit(): void {
        this.dataService.filterFactureFournisseurByStatus('Tous');
    }

}
